import { render, staticRenderFns } from "./tenderTemplateDetails.vue?vue&type=template&id=07e8ee24&"
import script from "./tenderTemplateDetails.js?vue&type=script&lang=js&"
export * from "./tenderTemplateDetails.js?vue&type=script&lang=js&"
import style0 from "./tenderTemplateDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports